import { render, staticRenderFns } from "./FeedImportHeaderMapping.vue?vue&type=template&id=5c61d722"
import script from "./FeedImportHeaderMapping.vue?vue&type=script&lang=js"
export * from "./FeedImportHeaderMapping.vue?vue&type=script&lang=js"
import style0 from "./FeedImportHeaderMapping.vue?vue&type=style&index=0&id=5c61d722&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c61d722')) {
      api.createRecord('5c61d722', component.options)
    } else {
      api.reload('5c61d722', component.options)
    }
    module.hot.accept("./FeedImportHeaderMapping.vue?vue&type=template&id=5c61d722", function () {
      api.rerender('5c61d722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modals/FeedImportHeaderMapping.vue"
export default component.exports